/*
 * Routes-staff.ts
 * Description: Includes the declaration of the
 * staff routes for Vue Router
 */

// Importing components
import PageStaff from '@/pages/staff/PageStaff.vue';
import PageStaffCreate from '@/pages/staff/PageStaffCreate.vue';
import PageStaffUpdate from '@/pages/staff/PageStaffUpdate.vue';

const routesStaff = [
    // Defining the staff page route
    {
        path: '/restaurants/:id/staff',
        name: 'staff',
        component: PageStaff,
        props: { id: Number },
        meta: { requiresAuth: true, ManageStaff: true },
    },
    // Defining the staff create page route
    {
        path: '/restaurants/:id/staff/create',
        name: 'staff-create',
        component: PageStaffCreate,
        props: { id: Number },
        meta: { requiresAuth: true, ManageStaff: true },
    },
    // Defining the staff update page route
    {
        path: '/restaurants/:id/staff/:user_id/update',
        name: 'staff-update',
        component: PageStaffUpdate,
        props: { id: Number, user_id: Number },
        meta: { requiresAuth: true, ManageStaff: true },
    },
];
export default routesStaff;
